<template>
  <div class="whole">
    <el-button
        v-if="isLanguage"
        style="margin-top: 5px"
        type="warning"
        size="small"
        v-show="showAlert"
        @click="openMessage">
      您有一条消息！
    </el-button>
    <el-button
        v-if="!isLanguage"
        style="margin-top: 5px"
        type="warning"
        size="small"
        v-show="showAlert"
        @click="openMessage">
      You have a message!
    </el-button>

    <div class="table">
      <!-- 上传按钮 -->
      <input class="input-file" type="file" @change="exportData" style="display:none" accept=".xlsx"/>
      <el-button type="success" size="small" @click="checkClick" style="margin: 5px">{{
          $t("button.Upload and Check")
        }}
      </el-button>
      <el-button type="success" size="small" @click="upClick" style="margin: 5px">{{
          $t("button.Upload to the database")
        }}
      </el-button>
      <!-- END -->

      <!-- 表格 -->
      <el-table
          :data="tableData_show"
          style="width: 100%"
          height="450"
          size="mini">
        <el-table-column
            :prop="item"
            :label="item"
            width="140"
            v-for="(item,index) in checkboxTableColumn"
            :key="'column'+index">
          <template v-slot="scope">
            <span :style="getPassCellStyle(scope.row)">{{ scope.row[item] }}</span>
          </template>
        </el-table-column>

        <template slot="empty">
          <p>{{ $t("label.empty") }}</p>
        </template>

      </el-table>
      <!-- END -->

      <!-- 分页 -->
      <el-pagination
          v-if="excelData !== 0"
          @size-change="handleSizeChange"
          @current-change="CurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
      </el-pagination>
      <!-- END -->
    </div>
  </div>
</template>


<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import request from "@/utils/request";

export default {
  name: "dataUpload",
  data() {
    return {
      uId: 0,
      resData: [],
      messageAlert: "",
      title: '',
      showAlert: false,
      isOk: false,
      isLanguage: '',
      years: ['2016', '2017', '2018', '2019', '2020'],
      citys: [],
      indexs: [],
      //所有键的值
      columnHeader: [],

      // 导入的excel的数据
      excelData: [],

      // 表格显示列
      checkboxTableColumn: [],

      //表格数据 - 上传
      tableData: [],

      //表格数据 - 展示
      tableData_show: [],

      // 当前分页
      currentPage: 1,

      // 每页显示数量
      pageSize: 10,

      // 数据总数
      total: 0
    }
  },

  methods: {
    getPassCellStyle(row) {
      if(this.isLanguage === true){
        if (row['格式是否通过'] === '格式通过') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      } else {
        if (row['pass'] === 'Format passed') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      }
    },
    openMessage() {
      if (this.isLanguage === true) {
        this.title = "提示"
      } else {
        this.title = "tip"
      }
      this.$notify({
        title: this.title,
        message: this.messageAlert,
        duration: 0
      });
    },
    // 将上传input框点击事件改为按钮
    checkClick() {
      document.querySelector(".input-file").click();
    },
    //上传按钮
    upClick() {
      let that = this
      if (that.isOk === true) {
        var listdata = []
        var everydata = {}
        this.tableData.forEach(function (e) {
              everydata = {
                city: {id: ''},
                eva_index: {id: '', year: ''},
                uploader: {id: ''},
                value: ''
              }
              everydata.city.id = parseInt(e.cityId)
              everydata.eva_index.id = parseInt(e.indexId)
              everydata.eva_index.year = e.year
              everydata.source = e.source
              everydata.uploader.id = parseInt(that.uId)
              everydata.value = e.value
              listdata.push(everydata)
            }
        )
        request.post('/upload', listdata).then(function (res) {
          if (res.data === true) {
            if (that.isLanguage === true) {
              alert("上传成功！")
            } else {
              alert("Successfully uploaded！")
            }
          } else {
            if (that.isLanguage === true) {
              alert("存在该数据，上传失败！")
            } else {
              alert("Database has this data, Failed uploaded！")
            }
          }
        }).catch(function (err) {
          if (that.isLanguage === true) {
            alert("上传失败！")
          } else {
            alert("Failed uploaded！")
          }
          console.log(err)
        })
      } else {
        if (that.isLanguage === true) {
          alert("格式存在问题，请更改后重新上传！")
        } else {
          alert("There is a problem with the format. Please change it and upload again!！")
        }
      }
    },

    // 解析excel
    exportData(event) {
      if (!event.currentTarget.files.length) {
        return;
      }
      let that = this;// 拿取文件对象
      let f = event.currentTarget.files[0];
      that.$emit('getMyExcelData', f);
      let reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        var wb = XLSX.read(data, {type: "buffer"});

        // 拿到当前表名 sheet1
        var sheetName = wb.SheetNames[0];
        // 根据表名 sheet1，拿到数据
        var sheet = wb.Sheets[sheetName];

        // 存储原始表头 + pass/格式是否通过
        var originalHeader = [];
        for (var key in sheet) {
          if (key.endsWith("1") && key.length === 2) {
            originalHeader.push(sheet[key].v);
          }
        }

        if (that.isLanguage === true) {
          originalHeader.push("格式是否通过")
        } else {
          originalHeader.push("pass")
        }


        // 定义新的表头
        var newHeader = ['city', 'year', 'index', 'source', 'value', 'pass'];

        // 将新的表头添加到工作表 - 方便检查年份、城市、指标是否存在
        XLSX.utils.sheet_add_aoa(sheet, [newHeader], {origin: 'A1'});

        // 把改过表头的sheet变成json数据
        var outdata = XLSX.utils.sheet_to_json(sheet);

        // 检查年份/指标/城市 是否存在系统中
        outdata.forEach(function (e) {
          // flag1 用来判断 年份
          let flag1 = that.years.findIndex((value) => {
            return value == e.year
          })
          if (flag1 !== -1) {
            var temp = []
            for (let n = 0; n < that.indexs.length; n++) {
              if (that.indexs[n].year == e.year) {
                temp = that.indexs[n].index
              }
            }
            // flag2 用来判断 指标
            let flag2 = temp.findIndex((obj) => {
              return obj.indexnamecn == e.index
            })
            if (flag2 !== -1) {
              if (that.isLanguage === true) {
                e.pass = "格式通过"
              } else {
                e.pass = "Format passed"
              }
              e.indexId = temp[flag2].indexid
              that.isOk = true
            } else {
              if (that.isLanguage === true) {
                e.pass = "该指标不存在"
              } else {
                e.pass = "The index does not exist"
              }
              that.isOk = false
            }
          } else {
            if (that.isLanguage === true) {
              e.pass = "该年份不存在"
            } else {
              e.pass = "The year does not exist"
            }
            that.isOk = false
          }
          // flag3 用来判断 城市
          let flag3 = that.citys.findIndex((value) => {
            return value.cityname == e.city
          })
          if (flag3 === -1) {
            if (that.isLanguage === true) {
              e.pass = "该城市不存在"
            } else {
              e.pass = "The city does not exist"
            }
            that.isOk = false
          } else {
            e.cityId = that.citys[flag3].cityid
          }
        })

        that.total = outdata.length;
        that.tableData = outdata;

        // 展示表格-只展示六列，后边的cityId，indexId不展示，但存储，用于提交数据
        if (that.isLanguage === true) {
          that.tableData_show = outdata.map(function (item) {
            return {
              "城市": item.city,
              "年份": item.year,
              "指标": item.index,
              "来源": item.source,
              "指标值": item.value,
              "格式是否通过": item.pass
            };
          });
        } else {
          that.tableData_show = outdata.map(function (item) {
            return {
              "city": item.city,
              "year": item.year,
              "index": item.index,
              "source": item.source,
              "value": item.value,
              "pass": item.pass
            };
          });
        }

        that.excelData = that.tableData_show;
        that.tableData_show = that.tableData_show.slice(0, that.pageSize);

        // 将原始表头展示
        that.checkboxTableColumn = originalHeader;
      };
      reader.readAsArrayBuffer(f);
    },

    // 分页切换
    CurrentChange(val) {
      this.currentPage = val;
      this.tableData_show = this.excelData.slice((val - 1) * this.pageSize, (val * this.pageSize) - 1);
    },
    // 每页显示数量改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.tableData_show = this.excelData.slice((this.currentPage - 1) * val, (this.currentPage * val) - 1);
    },
    getCity() {
      var di = {}
      request.get('/city').then(result => {
        for (let i = 0; i < result.data.length; i++) {
          di = {}
          if (this.isLanguage === true) {
            di.cityname = result.data[i].name_cn
          } else {
            di.cityname = result.data[i].name_en
          }
          di.cityid = result.data[i].id
          this.citys.push(di)
        }
      })
    },
    getIndex() {
      var te = []
      var dict = {}
      var indexDic = {}
      for (let i = 0; i < this.years.length; i++) {
        request.get("/EvaIndex?year=" + this.years[i]).then(result => {
          dict = {}
          if (result.data == null) {
            dict.year = this.years[i]
            dict.index = []
            this.indexs.push(dict)
          } else {
            te = []
            for (let j = 0; j < result.data.length; j++) {
              indexDic = {}
              if (this.isLanguage === true) {
                indexDic.indexnamecn = result.data[j].name_cn
              } else {
                indexDic.indexnamecn = result.data[j].name_en
              }
              indexDic.indexid = result.data[j].id
              te.push(indexDic)
            }
            dict.year = this.years[i]
            dict.index = te
            this.indexs.push(dict)
          }
        })
      }
    },
    getUser() {
      return new Promise((resolve, reject) => {
        request.get('/sysUser/currentUser').then((res) => { //接口1
          this.uId = res.data.id
          resolve(res)
        }).catch(e => {
          reject(e)
        })
      });
      // request.get('/sysUser/currentUser').then(function(res){
      //   that.uId=res.data.id
      // }).catch(function (err){
      //   console.log(err)
      // })
    },
    getReturn() {
      return new Promise((resolve, reject) => {
        request.get('/confirm/search?state=0').then((res) => { //接口2
          this.resData = res.data
          resolve(res)
        }).catch(e => {
          reject(e)
        })
      });
    },

    getMessage() {
      Promise.all([this.getReturn(), this.getUser()]).then(res => {
        var flag1
        flag1 = this.resData.findIndex(item => item.uploader.id === this.uId)
        console.log(res)
        if (flag1 !== -1) {
          if (this.isLanguage === true) {
            this.messageAlert = "您上传的数据被打回，请联系世界旅游联合会工作人员！"
          } else {
            this.messageAlert = "The data of you uploaded is returned, please contact the staff of the World Tourism Federation!"
          }
          this.showAlert = true
        }
      })
    }
  },
  mounted() {
    this.getCity()
    this.getIndex()
    this.getUser()
    this.getMessage()
  }, created() {
    if (this.$i18n.locale === 'cn') {
      this.isLanguage = true
    } else {
      this.isLanguage = false
    }
  }
}

</script>

<style scoped>
.whole {
  width: 95%;
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 30px;
  overflow: scroll;
  background: rgb(226, 226, 226);
}
</style>